import { Part, PartProduct } from '../../types/productSchema';

export const getDefaultQuantityByType = (part: Part | PartProduct, allQuantity: number): number => {
  switch (part) {
    case Part.Tyres:
    case Part.MotoTires:
    case Part.TruckTires:
    case Part.Disks:
    case PartProduct.Tyres:
    case PartProduct.MotoTires:
    case PartProduct.TruckTires:
    case PartProduct.Disks:
      return allQuantity >= 4 ? 4 : allQuantity;
    case PartProduct.Batteries:
    case Part.Batteries:
      return 1;
    default:
      return 1;
  }
};

export const isEquipment = (part: Part | PartProduct, quantity: number): boolean => {
  switch (part) {
    case Part.Tyres:
    case Part.MotoTires:
    case Part.TruckTires:
    case Part.Disks:
    case PartProduct.Tyres:
    case PartProduct.MotoTires:
    case PartProduct.TruckTires:
    case PartProduct.Disks:
      return quantity >= 4;
    default:
      return quantity === 1;
  }
};
